/**
 * ＣＷＳカテゴリ関連マスタ用VOクラス
 */
export class KYMW5400commonModel {
  // 共通パラメータ
  /** カテゴリ区分 */
  public categoryDiv = String('');
  /** 在庫限定フラグ */
  public stockLimitFlg = String('');

  // カテゴリ商品マスタ項目
  /** 受注コード */
  public orderCode = String('');

  // カテゴリマスタ/カテゴリ商品マスタ項目
  /** カテゴリコード */
  public categoryCode = String('');
  /** カテゴリ名称 */
  public categoryName = String('');
  /** 親カテゴリコード */
  public categoryParent = String('');
  /** カテゴリ階層 */
  public categoryLevel: number;
  /** 表示順 */
  public showSeq: number;

  /** カテゴリ関連情報リスト */
  public goodsCategoryInfoList: Array<any> = null;
  /** 更新区分(0：登録、1：削除、2:更新) */
  public updateDiv = String('');
  /** Ｐコード */
  public pCode = String('');
  /** 生協コード */
  public coopCode = String('');
  /** EC掲載順 */
  public ecShowSeq: number;

  // カテゴリマスタ/カテゴリ商品マスタ項目
  /** 登録日時 */
  public registDate = String('');
  /** 登録ユーザ */
  public registUser = String('');
  /** 更新日時 */
  public updateDate = String('');
  /** 更新ユーザ */
  public updateUser = String('');

}
